import { useEffect, useSyncExternalStore } from "react";

let hidden = 0;
const listeners = new Set<() => void>();
const emit = () => listeners.forEach((l) => l());

export function useHideGlobalMapFab() {
  useEffect(() => {
    hidden += 1;
    emit();
    return () => {
      hidden -= 1;
      emit();
    };
  }, []);
}

export function useGlobalMapFabHidden() {
  return useSyncExternalStore(
    (l) => {
      listeners.add(l);
      return () => listeners.delete(l);
    },
    () => hidden > 0,
    () => false,
  );
}
